<template>
  <BreadCrumb PageTitle="Détails du modèle de notification" />
  <ViewModeleNotification />
</template>

<script lang="ts">
  import { defineComponent } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ViewModeleNotification from "../../components/ModeleNotification/ViewModeleNotification.vue";

  export default defineComponent({
    name: "ViewModeleNotificationPage",
    components: {
      BreadCrumb,
      ViewModeleNotification,
    },
  });
</script>